import { useState } from "react";
import { GraduationCap, Sparkles } from "lucide-react";
import { LeadFormDialog } from "@/components/LeadFormDialog";

// Floating CTA bubble — pulses subtly to draw attention and on tap opens the
// lead-capture dialog (Name / Country / Email / Mobile). The visit-to-lesson
// link still exists via the in-page header / menu so we don't strand SEO.
export const BookLessonBubble = () => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        data-testid="book-lesson-bubble"
        aria-label="Book a live Quran class"
        className="group fixed bottom-5 right-5 sm:bottom-7 sm:right-7 z-40 select-none"
      >
        {/* Pulsing rings */}
        <span aria-hidden className="absolute inset-0 rounded-full bg-primary/40 animate-ping-slow" />
        <span aria-hidden className="absolute inset-0 rounded-full bg-accent/30 animate-ping-slower" />

        {/* The bubble itself */}
        <span
          className="relative inline-flex items-center gap-1.5 sm:gap-2 h-12 sm:h-16 rounded-full pl-2.5 pr-3 sm:pl-4 sm:pr-5 shadow-xl border border-accent/50
                     bg-gradient-to-br from-emerald-700 via-emerald-600 to-emerald-800 text-white
                     transition-all duration-300 ease-out hover:scale-105 hover:shadow-2xl"
          style={{ boxShadow: "0 12px 36px -8px hsla(160,84%,18%,0.6), 0 0 0 4px hsla(45,64%,52%,0.18)" }}
        >
          <span className="relative w-8 h-8 sm:w-12 sm:h-12 rounded-full bg-amber-300/95 text-emerald-900 inline-flex items-center justify-center shrink-0">
            <GraduationCap className="w-4 h-4 sm:w-6 sm:h-6" />
            <span aria-hidden className="absolute -top-1 -right-1 w-3 h-3 sm:w-3.5 sm:h-3.5 bg-amber-200 rounded-full animate-bounce-tiny inline-flex items-center justify-center">
              <Sparkles className="w-2 h-2 sm:w-2.5 sm:h-2.5 text-emerald-800" />
            </span>
          </span>
          <span className="flex flex-col leading-tight text-left">
            <span className="text-[9px] sm:text-[11px] uppercase tracking-[0.18em] text-amber-200">Book Free</span>
            <span className="font-display text-sm sm:text-lg whitespace-nowrap">Live Quran Classes</span>
          </span>
        </span>
      </button>

      <LeadFormDialog open={open} onOpenChange={setOpen} source="bubble" />
    </>
  );
};
